export default {
    path: '/login',
    meta: {
        title: '登录',
        keepAlive: false
    },
    component: () => import("@/views/login/index.vue")
}